import React, { useState } from "react";
import Card from "./components/card/Card";
import "./home.scss";
import FormTitle from "./components/formTitle/FormTitle";
import ModalDialog from "./components/modal/ModalDialog";

const formName = [
  {
    name: "TT Check Socket",
    to: "ttchecksocket",
    isBilat: true,
  },
  {
    name: "TF Check Socket",
    to: "tfchecksocket",
    isBilat: true,
  },
  /*{ //Temporarily hidden
    name: "WillowWood Core™ TT with RevoFit",
    to: "ttstandardrevo",
  },
  {
    name: "WillowWood Core™ TF with RevoFit",
    to: "tfstandardrevo",
  },*/
  {
    name: "TT Definitive Socket",
    to: "ttdefinitive",
    isBilat: true,
  },
  {
    name: "TF Definitive Socket",
    to: "tfdefinitive",
    isBilat: true,
  },
  /*{ //Temporarily hidden
    name: "TT One® Socket",
    to: "ttonesocket",
  },
  {
    name: "TF One® Socket",
    to: "tfonesocket",
  },*/
  {
    name: "Xtremity TT Socket",
    to: "ttxtremity",
    isBilat: false,
  },
  {
    name: "Knee Bundle",
    to: "kneebundle",
    isBilat: false,
  },
  {
    name: "Liners",
    to: "liners",
    isBilat: false,
  }
];

const Home = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("TT check socket");
  const [to, setTo] = useState("");

  const [value, setValue] = useState("2");
  const [isBilat,setBilat] = useState(false);

  const handleChange = (event, selected) => {
    setValue(event.target.value);
    if (to.includes("-")) {
      const parts = to.split("-");
      const updatedString = parts[0] + "-" + event.target.value;
      setTo(updatedString);
    } else {
      setTo(to + "-" + event.target.value);
    }
    // setSelectedForms(selected);
  };

  const handleClickOpen = (name, to,isBilat) => {
    setTitle(name);
    setOpen(true);
    setTo(to);
    setBilat(isBilat)
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="">
        <div className="formCardWrapper">
          <FormTitle
            title="Order Forms for Custom Products"
            description="For your convenience, all WillowWood custom product order forms are listed below. "
          />
          <div className="formSelectCard">
            {formName.map((name) => (
              <Card
                key={name.name}
                formTitle={name.name}
                handleClickOpen={() => handleClickOpen(name.name, name.to, name.isBilat)}
              />
            ))}
          </div>

          <div className="cardModal">
            <ModalDialog
              open={open}
              formTitle={title}
              handleClose={handleClose}
              to={to}
              value={value}
              handleChange={handleChange}
              isBilat={isBilat}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
